// Status como pílula tingida (fg = ponto e texto; bg = fundo tênue).
// Cores refinadas, distintas do ouro de marca (âmbar, cobre, teal, verde).

export const orderStatusInfo = {
    '0': { color: '#5B6472', bg: '#E7E9ED', label: 'Recebido' },
    '1': { color: '#8A6D1F', bg: '#F4EBCB', label: 'Aprovado' },
    '2': { color: '#9C4B1B', bg: '#F6E3D4', label: 'Em produção' },
    '3': { color: '#215E54', bg: '#D9ECE6', label: 'Pronto' },
    '4': { color: '#2F6B45', bg: '#DCEBDF', label: 'Entregue' },
};

// Sequência de estágios para a linha do tempo do cliente.
export const orderStatusStages = ['Recebido', 'Aprovado', 'Em produção', 'Pronto', 'Entregue'];

export const quoteStatusInfo = {
    0: { color: '#8A6D1F', bg: '#F4EBCB', label: 'Aguardando' },
    1: { color: '#215E54', bg: '#D9ECE6', label: 'Respondido' },
    completed: { color: '#5B6472', bg: '#E7E9ED', label: 'Concluído' },
};

/** Resolve chip de status a partir de completed_at + is_answered. */
export function resolveQuoteStatus(quote) {
    if (!quote) return quoteStatusInfo[0];
    if (quote.completed_at) return quoteStatusInfo.completed;
    const answered = quote.is_answered === true || quote.is_answered === 1 || quote.is_answered === '1';
    return answered ? quoteStatusInfo[1] : quoteStatusInfo[0];
}

export const metalList = [
    { value: 1, label: 'Ouro 18K' },
    { value: 2, label: 'Ouro 10K' },
    { value: 3, label: 'Prata 950' },
];
